import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white2};
  padding-bottom: 1rem;
`;

export const SkeletonContainer = styled.div`
  padding: 0 1.5rem;
`;

export const FabricationOrdersHeader = styled.header`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1rem 1.5rem 2.4rem 1.5rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-size: 1rem;
  margin-bottom: 1rem;
`;

export const DefaultMessage = styled.div`
  font-family: ${({ theme }) => theme.fonts.workSans};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2.4rem;
`;

export const FabricationOrdersFilter = styled.div`
  display: flex;
  max-width: 47.5rem;
  column-gap: 1.5rem;
  align-items: flex-end;
  margin-top: 1.5rem;

  & > button {
    min-width: 10.75rem;
  }

  & > div {
    min-width: 16.875rem;
  }
`;
